<template>
  <div class="overflow-y-scroll">
    <div
      class="flex flex-col bg-white min-h-full
                transition-all duration-100 ease-in
                min-w-64 w-max-content w-max max-w-64 xxl:max-w-80 relative z-10"
    >
      <ul class="ml-5 mt-32">
        <!-- BEGIN List modules -->
        <li
          v-for="(page) in listPages[form.type]"
          :key="page.id"
          :id="page.id"
          class="list-none"
        >
          <div 
            class="group leading-4 cursor-pointer table flex-wrap
                            h-14 2xl:h-16 w-auto max-w-60 border border-transparent rounded-lg
                            hover:bg-pink-600 hover:text-white
                            focus:outline-none transition ease-in-out duration-150 text-gray-600"
            :class="{'bg-pink-300':currentStep === page.name,}"
          >
            <div
              class="items-center p-4 2xl:p-5 rounded-lg
                                text-indigo-600
                                group-hover:text-white group-hover:bg-pink-600
                                transition ease-in-out duration-150 m-1"
                            :class="{'bg-pink-100':currentStep === page.name }"
                        >
                            <icon :name="page.icon" />
                        </div>
                        <div
                            class="table-cell text-base align-middle pl-1 pr-3 group-hover:text-white"
                            :class="{'text-gray-900':currentStep === page.name}"
                            @click="SET_CURRENTSTEP(page.name); $emit('changePage')"
                        >
                            {{page.libelle}}
                        </div>
                    </div>
                </li>
                <!-- END List modules -->
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
import Icon from './Icon';
import Layout from '../mixins/Layout';
import Constants from './../constants';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name:'MenuCvFormulaire',
  components: {
    Icon
  },
    
  mixins: [Layout],
    
  data: function(){
    return{
      premiumPermissions:[],
      listPages: Constants.CV_PAGES,
    };
  },

  methods: {
    ...mapMutations({
      SET_CURRENTSTEP: 'curriculumVitae/SET_CURRENTSTEP', 
    }),

  },

  computed:{
    ...mapGetters({
      currentStep: 'curriculumVitae/currentStep',
      form: 'curriculumVitae/form',
    }),
  }

};
</script>
